<template>
  <div class="notifications-link">
    <woot-button
      class-names="notifications-link--button"
      variant="clear"
      color-scheme="secondary"
      :class="{ 'is-active': isNotificationPanelActive }"
      @click="openNotificationPanel"
    >
      <fluent-icon icon="alert" :class="{ shake: isShaking }" />
      <span v-if="unreadCount" class="badge warning">{{ unreadCount }}</span>
    </woot-button>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    notificationEventKey: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isShaking: false,
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      notificationMetadata: 'notifications/getMeta',
    }),
    unreadCount() {
      if (!this.notificationMetadata.unreadCount) {
        return '';
      }

      return this.notificationMetadata.unreadCount < 100
        ? `${this.notificationMetadata.unreadCount}`
        : '99+';
    },
    isNotificationPanelActive() {
      return this.$route.name === 'notifications_index';
    },
  },
  watch: {
    notificationEventKey(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }

      this.isShaking = false;
      this.$nextTick(() => {
        this.isShaking = true;
        window.clearTimeout(this.shakeTimer);
        this.shakeTimer = window.setTimeout(() => {
          this.isShaking = false;
        }, 2000);
      });
    },
  },
  beforeDestroy() {
    window.clearTimeout(this.shakeTimer);
  },
  methods: {
    openNotificationPanel() {
      if (this.$route.name !== 'notifications_index') {
        this.$emit('open-notification-panel');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.badge {
  position: absolute;
  right: 0;
  top: var(--space-smaller);
}

.notifications-link {
  margin: auto 0;

  @media screen and (max-width: 768px) {
    display: none;
  }

  .notifications-link--button {
    display: flex;
    position: relative;
    border-radius: var(--border-radius-large);
    border: 1px solid transparent;
    color: var(--s-600);
    margin-right: var(--space-smaller);

    &:hover {
      background: var(--w-50);
      color: var(--s-600);
    }

    &:focus {
      border-color: var(--c-500);
    }

    &.is-active {
      background: var(--w-50);
      color: var(--c-500);
    }
  }
}

.shake {
  transform-origin: top center;
  display: inline-block;
  animation: shake 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) 4;
}

@keyframes shake {
  0% { transform: rotate(0); }
  15% { transform: rotate(10deg); }
  30% { transform: rotate(-10deg); }
  45% { transform: rotate(8deg); }
  60% { transform: rotate(-8deg); }
  75% { transform: rotate(4deg); }
  85% { transform: rotate(-4deg); }
  100% { transform: rotate(0); }
}
</style>
